import { render } from "./SectionFooter.vue?vue&type=template&id=0231391e&scoped=true"
import script from "./SectionFooter.vue?vue&type=script&lang=js"
export * from "./SectionFooter.vue?vue&type=script&lang=js"

import "./SectionFooter.vue?vue&type=style&index=0&id=0231391e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0231391e"]])

export default __exports__